<template>
  <div class="d-flex res-topology account-topology">
    <div class="c-left">
      <res-brand :dataSource="dataSource" :accountVisible="dataSource.isChildrenShow" @click="handleBrandClick" />
    </div>
    <div v-if="dataSource.isChildrenShow" :class="{'bl-none': isEmpty(dataSource.accounts) }">
      <ul class="list">
        <li class="item d-flex" v-for="(account, nidx) in dataSource.accounts" :key="nidx">
          <res-account :dataSource="dataSource" :account="account" :isLast="nidx === dataSource.accounts.length - 1" :cls="getAccountCls(nidx)" :hostVisible="account.isChildrenShow" @click="(e) => handleAccountClick(e, account)" />
          <host-topology :dataSource="dataSource" :account="account" v-if="account.isChildrenShow" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { RES_ICON_MAP } from '@Network/sections/Topology/constants'
import ResMixin from '@Network/sections/Topology/ResMixin'
import ResAccount from '../ResAccount'
import ResBrand from '../ResBrand'
import HostTopology from '../Host'

export default {
  name: 'AccountTopology',
  components: {
    ResAccount,
    HostTopology,
    ResBrand,
  },
  mixins: [ResMixin],
  props: {
    classic: Boolean,
    physical: Boolean,
    dataSource: Object,
    // initExpand: Number,
  },
  data () {
    return {
      RES_ICON_MAP,
    }
  },
  computed: {
  },
  watch: {
    // initExpand (val) {
    //   this.hostVisible = this.accounts.map(item => {
    //     return val % 2 === 1
    //   })
    // },
  },
  methods: {
    handleBrandClick (e) {
      this.$set(this.dataSource, 'isChildrenShow', !this.dataSource.isChildrenShow)
    },
    handleAccountClick (e, account) {
      this.$set(this.dataSource, account.showId, !account.isChildrenShow)
    },
    hideLeftBorder (account) {
      console.log('accouyn', account)
      if (!account.isChildrenShow) {
        return false
      } else {
        if (!account.hosts.length) {
          return false
        }
        if (account.hosts.length === 1) {
          if (!account.host[0].isChildrenShow) {
            return false
          } else if (!account.host[0].isociate_devices.length) {
            return false
          }
        }
      }
      return true
    },
    getAccountCls (idx) {
      if (idx !== 0) {
        const prevAccount = this.dataSource.accounts[idx - 1]
        if (!prevAccount.isChildrenShow || !prevAccount.hosts.length) {
          return 'border-left-122'
        } else {
          // if (prevAccount.)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "@Network/sections/Topology/index.scss";
.res-topology {
  margin-left: 50px !important;
  .wire {
    width: 150px !important;
    // .vpc {
    //   width: 200px;
    // }
  }
}
.c-left {
  width: 100px;
  display: flex;
  .line {
    height: 0px;
    width: 100%;
    border: 1px solid #2D3A4D;
  }
}
.account-topology-c-right {
  &::after {
    height: 208px !important;
  }
}
.account-no-hosts-c-right {
  &::after {
    height: 128px !important;
  }
}
.res-topology .c-right::after {
  width: 10px;
  left: -5px;
  bottom: 0;
}
</style>
